import { MenuItem, MenuItemProps, Spinner } from "@chakra-ui/react";

type Props = MenuItemProps & {
  isLoading?: boolean;
};

export default function ExportMenuItem({
  isLoading,
  isDisabled,
  ...rest
}: Props) {
  return (
    <MenuItem
      icon={isLoading ? <Spinner size="sm" color="gray" /> : undefined}
      isDisabled={isLoading || isDisabled}
      {...rest}
    />
  );
}
